import { ReactNode } from "react";

import Typography, { TypographyProps } from "../Typography";
import styles from "./styles.module.css";

type PageInfoHeaderTitleProps = {
  id?: string;
  title: ReactNode;
  titleTag?: TypographyProps["tag"];
};

const PageInfoHeaderTitle = ({ title, titleTag = "h2", id }: PageInfoHeaderTitleProps) => (
  <Typography tag={titleTag} className={styles.title} id={id}>
    {title}
  </Typography>
);

PageInfoHeaderTitle.displayName = "DS.PageInfoHeaderTitle";

export default PageInfoHeaderTitle;
